import { render, staticRenderFns } from "./interfaces.vue?vue&type=template&id=d95d6a08&scoped=true&"
import script from "./interfaces.vue?vue&type=script&lang=ts&"
export * from "./interfaces.vue?vue&type=script&lang=ts&"
import style0 from "./interfaces.vue?vue&type=style&index=0&id=d95d6a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95d6a08",
  null
  
)

export default component.exports